import React from "react";
import { Box, Typography, Grid } from "@mui/material";

import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";

function Footer() {
  return (
    <Box
      sx={{
        flexGrow: 1,
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          backgroundColor: "#000000",
          p: { xs: 0, md: 0 },
          pb: { xs: 5, md: 5 },
          pt: { xs: 5, md: 5 },
        }}
      >
        <Grid container spacing={4} justifyContent="center" maxWidth="lg">
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h3"
              gutterBottom
              sx={{
                pt: 3,
                color: "#FFFFFF",
                fontSize: {
                  xs: "1.9rem",
                  sm: "1.9rem",
                  md: "1.9rem",
                },
                textAlign: "center",
              }}
            >
              About Linus100
              <Box
                sx={{
                  backgroundColor: "#FFFFFF",
                  height: "0.1px",
                  width: "100%",
                }}
              />
            </Typography>
            <Typography
              variant="h3"
              gutterBottom
              sx={{
                color: "#FFFFFF",
                fontSize: {
                  xs: "1rem",
                  sm: "1rem",
                  md: "1rem",
                },
                textAlign: "center",
                width: "350px",
                pb: 1,
              }}
            >
              Linus100 stands at the forefront of innovation, reshaping the
              digital, cloud, and software landscape with forward-thinking IT
              solutions.
            </Typography>
            <Typography
              variant="h3"
              gutterBottom
              sx={{
                color: "#FFFFFF",
                fontSize: {
                  xs: "1rem",
                  sm: "1rem",
                  md: "1rem",
                },
                textAlign: "center",
                width: "350px",
              }}
            >
              Our offerings are fully cost-efficient and designed to boost your
              business performance to new heights.
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h3"
              gutterBottom
              sx={{
                color: "#FFFFFF",
                fontSize: {
                  xs: "1.9rem",
                  sm: "1.9rem",
                  md: "1.9rem",
                },
                textAlign: "left",
                pr: { xs: 0, md: 35 },
                pt: 3,
              }}
            >
              Contact Info
              <Box
                sx={{
                  backgroundColor: "#FFFFFF",
                  height: "0.1px",
                  width: "100%",
                }}
              />
            </Typography>

            <Box sx={{ pl: { xs: 5, md: 5 }, pt: { xs: 0, md: 2 } }}>
              <Grid container spacing={2}>
                {/* Email */}
                <Grid
                  item
                  xs={12}
                  sm={4}
                  sx={{ display: "block", alignItems: "center" }}
                >
                  <Box sx={{ display: "flex", pb: 1 }}>
                    <EmailIcon sx={{ mr: 1, color: "primary.main" }} />
                    <Typography sx={{ color: "#fff" }}>
                      operations_mr@linus100.com
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", pb: 1 }}>
                    <PhoneIcon sx={{ mr: 1, color: "primary.main" }} />
                    <Typography sx={{ color: "#fff" }}>
                      +91 9538222102
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", pb: 1 }}>
                    <LocationOnIcon sx={{ mr: 1, color: "primary.main" }} />
                    <Typography sx={{ color: "#fff" }}>
                      Linus 100, 633/3, 1st Main, 1st Cross, Mathikere Bangalore
                      -560054
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "block",
          backgroundColor: "#000000",
        }}
      >
        <Typography
          sx={{
            color: "#fff",
            backgroundColor: "#000000",
            textAlign: "center",
            py: 1, // optional: adds vertical padding
          }}
        >
          Copyright © 2025 - Linus100
        </Typography>
      </Box>
    </Box>
  );
}

export default Footer;
